import classes from 'classnames';
import HelpIcon from 'assets/icons/help.svg?react';
import styles from './HelpInfo.module.scss';
import Typography from 'components/Typography/Typography';

export type Props = {
  title: string;
  text: string;
  className?: string;
  dataTest?: string;
};

export default function HelpInfo({
  title,
  text,
  className,
  dataTest = 'helpInfo',
}: Props) {
  return (
    <div
      className={classes(styles['help-wrapper'], className)}
      data-test={dataTest}
    >
      <div className={styles.icon}>
        <HelpIcon data-test="helpInfo-icon" />
      </div>
      <div className={styles['help-info-wrapper']}>
        <Typography
          kind="h1"
          size="s"
          dataTest="helpInfo-title"
          fontWeight={700}
        >
          {title}
        </Typography>
        <p
          className={styles['information-text']}
          data-test="helpInfo-text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </div>
    </div>
  );
}
